<template>
  <div class="tonglan">
   <!--列表内容-->
   <div class="xwlb">
    <!--列表左边-->
    <div class="lbl">
     <div class="dbti">
      <h1 style=" font-size:14px">最新文章</h1>
      <div class="dbti" v-for="article in articleList" :key="article.ywArticleId">
       <h3><router-link :to="'/ArticleDetail?id=' + article.ywArticleId">{{article.title}}</router-link><span>{{article.publishTime}}</span></h3>
       <ul>
        <li><span>{{article.content}}</span>
        <router-link :to="'/ArticleDetail?id=' + article.ywArticleId"><span class="blue">[更多]</span></router-link></li>
       </ul>
      </div>
     </div>
    </div>
   </div>
  </div>
</template>
<script>
import { getArticleList } from '../api/article'
export default {
  name: 'Article',
  data () {
    return {
      articleList: []
    }
  },
  mounted () {
    getArticleList().then(response => {
      this.articleList = response.data
    })
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.xwlb {
  width: 1210px;
}

.lbl {
  width: 1150px;
  float: left;
  background-color: #ffffff;
  border: solid 1px #f0f0f0;
  padding: 15px;
  margin-bottom: 10px;
  .dbti {
    width: 1130px;
    border-bottom: 1px dashed #dcdcdc;
    padding-bottom: 15px;
    margin-bottom: 5px;
  }

  .dbti h3 {
    font-size: 14px;
    font-weight: bold;
    width: 100%;
    overflow: hidden;
    line-height: 24px;
  }

  .dbti h3 span {
    float: right;
    color: #666666;
    font-weight: normal;
    line-height: 24px;
  }

  .dbti ul {
    padding: 5px 0px;
  }

  .dbti ul li {
    line-height: 24px;
    font-size: 14px;
    width: 100%;
    overflow: hidden;
  }
}
</style>
